<div class="p-t-sm">
  <table class="teams-table">
    <thead class="teams-table-header-sticky-top">
    <tr>
      <td class="search-td" rowspan="2">
        <gp-teams-filter
          [userId]="userId"
          [isIframe]="isIframe"
          [teams]="teams"
          [selectedTeam]="selectedTeam"
          [isCustomTeam]="isCustomTeam"
          (onOpenCreateTeamModal)="openCreateTeamModal()"
          (onChangeTeam)="changeTeam($event, searchTerm)"
          (onDeleteTeam)="deleteTeam()"
          (search)="filterTeam($event)"
        >
        </gp-teams-filter>
      </td>
      <td class="week-cell" colspan="7">
        <div class="week-bar fc-toolbar equal-basis">
          <div class="fc-left">
            <button type="button"
                    [disabled]="isLoading"
                    class="week-button fc-prev-button fc-button fc-state-default fc-corner-left fc-corner-right"
                    (click)="changeDate('dec')">
              <span class="fc-icon fc-icon-left-single-arrow direction-ltr"></span>
            </button>
          </div>
          <span>{{'Week' | translate}} {{week1Num}}, {{monthRange1Week}}</span>
        </div>
      </td>
      <td class="week-cell" colspan="7">
        <div class="week-bar fc-toolbar equal-basis">
          <div class="fc-right">
            <button type="button"
                    [disabled]="isLoading"
                    class="week-button fc-next-button fc-button fc-state-default fc-corner-left fc-corner-right"
                    (click)="changeDate('inc')">
              <span class="fc-icon fc-icon-right-single-arrow direction-ltr"></span>
            </button>
          </div>
          <span>{{'Week' | translate}} {{week2Num}}, {{monthRange2Week}}</span>
        </div>
      </td>
    </tr>
    <tr>
      <td class="day-cell"
          *ngFor="let dayLabel of dayLabels">
        <span>{{dayLabel}}</span>
      </td>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngIf="!isLoading">
      <tr *ngFor="let employee of employees; let empIndex = index;">
        <td class="b-b">
          <gp-teams-list-employee
            [employee]="employee"
            [isIframe]="isIframe"
            (menuClicked)="onMenuClick($event)"
          >
          </gp-teams-list-employee>
        </td>
        <td class="standart-cell" *ngFor="let td of workCycle[empIndex];"
            [style.backgroundColor]="td.color"
            [style.color]="td.textColor">
          <div class="table-content-container">
            <span class="day-label">{{td.label | translate}}</span>

            <ng-container *ngIf="absenceMap.get(td.date + '-' + employee.id)">
              <ng-container *ngFor="let absence of absenceMap.get(td.date + '-' + employee.id)">
                <ng-container *ngIf="!absence.attributes.status">
                  <gp-calendar-absence
                    class="display-block"
                    [event]="absence"
                    [showContent]="false"
                    [date]="td.date | date:'yyyy-MM-dd'"
                    [isTeamPlanning]="true"
                    [isReadOnly]="true">
                  </gp-calendar-absence>
                </ng-container>

                <ng-container *ngIf="absence.attributes.status">
                  <gp-calendar-pending-absence
                    class="display-block"
                    [event]="absence"
                    [isTeamPlanning]="true"
                    [date]="td.date | date:'yyyy-MM-dd'">
                  </gp-calendar-pending-absence>
                </ng-container>
              </ng-container>
            </ng-container>

          </div>
        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</div>

<div *ngIf="!isIframe">
  <div [refreshOn]="dataLoaded" [gp-sticky]="'bottom'" style="z-index: 2">
    <table *ngIf="!isLoading && employees.length" class="teams-table avail-table">
      <tr>
        <td class="avail-table-first-cell">
          {{ 'TEAM_PLANNING.team_availability' | translate }}:
        </td>
        <td *ngFor="let availValue of availablityValues"
            class="avail-table-standart-cell"
            [ngClass]="{'red-cell': availValue.percent <= 0.5}">
          {{availValue.percent.toFixed(0)}}%
        </td>
      </tr>
      <tr>
        <td class="avail-table-first-cell">
          {{ 'TEAM_PLANNING.people_availability' | translate }}:
        </td>
        <td *ngFor="let availValue of availablityValues"
            class="avail-table-standart-cell"
            [ngClass]="{'red-cell': availValue.percent <= 0.5}">
          {{availValue.people.toFixed(1)}}
        </td>
      </tr>
    </table>
  </div>

  <div *ngIf="isIframe" class="frame-footer">
    <table *ngIf="!isLoading && employees.length" class="teams-table avail-table">
      <tr>
        <td class="avail-table-first-cell">
          {{ 'TEAM_PLANNING.team_availability' | translate }}:
        </td>
        <td *ngFor="let availValue of availablityValues"
            class="avail-table-standart-cell"
            [ngClass]="{'red-cell': availValue.percent <= 0.5}">
          {{availValue.percent.toFixed(0)}}%
        </td>
      </tr>
      <tr>
        <td class="avail-table-first-cell">
          {{ 'TEAM_PLANNING.people_availability' | translate }}:
        </td>
        <td *ngFor="let availValue of availablityValues"
            class="avail-table-standart-cell"
            [ngClass]="{'red-cell': availValue.percent <= 0.5}">
          {{availValue.people.toFixed(1)}}
        </td>
      </tr>
    </table>
  </div>

  <div class="center-align" *ngIf="isLoading">
    <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin"></i>
  </div>

  <gp-modal gp-modal="create-team"
            [closable]="false"
            #createPopup>
    <div class="gp-modal-title">
      {{ 'TEAM_PLANNING.create_new_team' | translate }}
    </div>
    <form novalidate class="gp-modal-body clearfix">
      <div class="col-md-12">
        <label for="teamName">{{'TEAM_PLANNING.team_name' | translate}}</label>
        <input type="text" class="form-control" id="teamName" [formControl]="teamName">
      </div>
    </form>
    <div class="gp-modal-footer">

      <div class="btn-bar-wrapper">
        <div class="btn-bar btn-bar-sm btn-bar-align-end">
          <button type="button"
                  [disabled]="teamName.invalid"
                  class="btn btn-dark p-x-md"
                  (click)="createTeam()">
            {{ 'EMPLOYEE_FORM.submit' | translate }}
          </button>
          <button type="button"
                  class="btn btn-secondary p-x-md"
                  (click)="cancelCreateTeam(createPopup)">
            {{ 'FORMS.cancel' | translate }}
          </button>
        </div>
      </div>

    </div>
  </gp-modal>

  <gp-modal gp-modal="edit-event"
            [closable]="true"
            #eventpopup>
    <div class="gp-modal-title">
      {{ 'TEAM_PLANNING.add_unj_absence' | translate }}
    </div>
    <div class="gp-modal-body">
      <form novalidate [formGroup]="eventForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ 'FORMS.begin_date' | translate }}</label>
              <datepicker-input #begindate
                                name="begindate"
                                [(ngModel)]="absenceEvent.begin"
                                [minDate]="minDate"
                                [maxDate]="maxDate"
                                [hasEternity]="true"
                                (ngModelChange)="onChangeDates()"
                                formControlName="beginDate">
              </datepicker-input>
            </div>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ 'FORMS.end_date' | translate }}</label>
              <datepicker-input #enddate
                                name="enddate"
                                test-id="endDateModal"
                                [(ngModel)]="absenceEvent.end"
                                [minDate]="minDate"
                                [maxDate]="maxDate"
                                [hasEternity]="true"
                                (ngModelChange)="onChangeDates()"
                                formControlName="endDate">
              </datepicker-input>
            </div>
          </div>
        </div>
        <ul class="error-list begin-before-end" *ngIf="!isBeginBeforeEnd">
          <li>{{'FORMS.VALIDATORS.end_date_earlier_start_date' | translate}}</li>
        </ul>
        <div class="row" style="margin-bottom: 1rem;"
             *ngIf="!isSingleDay()">
          <div class="col-md-6">
            <div class="form-group">
              <div>{{ 'PAYROLL_PREPARE.begin_date_duration' | translate }}:</div>
              {{ 'PAYROLL_PREPARE.duration' | translate }}:
              <number-input #beginRangeHour
                            [type]="'integer'"
                            [(ngModel)]="timeFields.beginDateRange.hours"
                            [classes]="['time-input']"
                            formControlName="beginHours"
                            (blur)="checkDateRange('beginDateRange', 'begin')"
                            (keyup)="setDateRange('beginDateRange',
                          beginRangeHour.input.nativeElement.value,
                          beginRangeMinute.input.nativeElement.value,
                          'begin',
                          true)">
              </number-input>
              {{'PAYROLL_PREPARE.h' | translate}}
              <number-input #beginRangeMinute
                            [type]="'integer'"
                            [(ngModel)]="timeFields.beginDateRange.minutes"
                            [classes]="['time-input']"
                            formControlName="beginMinutes"
                            (blur)="checkDateRange('beginDateRange', 'begin')"
                            (keyup)="setDateRange('beginDateRange',
                          beginRangeHour.input.nativeElement.value,
                          beginRangeMinute.input.nativeElement.value,
                          'begin',
                          true)">
              </number-input>
              {{'PAYROLL_PREPARE.m' | translate}}
              <!--{{ getRangeDurationLabel(currentEvent.beginDateRange, 'begin')}}-->
              <!--[step]="0.25"-->
            </div>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-6">
            <div class="form-group">
              <div>{{ 'PAYROLL_PREPARE.end_date_duration' | translate }}:</div>
              {{ 'PAYROLL_PREPARE.duration' | translate }}:
              <number-input #endRangeHour
                            [type]="'integer'"
                            [(ngModel)]="timeFields.endDateRange.hours"
                            [classes]="['time-input']"
                            formControlName="endHours"
                            (blur)="checkDateRange('endDateRange', 'end')"
                            (keyup)="setDateRange('endDateRange',
                          endRangeHour.input.nativeElement.value,
                          endRangeMinute.input.nativeElement.value,
                          'end')">
              </number-input>
              {{'PAYROLL_PREPARE.h' | translate}}
              <number-input #endRangeMinute
                            [type]="'integer'"
                            [(ngModel)]="timeFields.endDateRange.minutes"
                            [classes]="['time-input']"
                            formControlName="endMinutes"
                            (blur)="checkDateRange('endDateRange', 'end')"
                            (keyup)="setDateRange('endDateRange',
                          endRangeHour.input.nativeElement.value,
                          endRangeMinute.input.nativeElement.value,
                          'end')">
              </number-input>
              {{'PAYROLL_PREPARE.m' | translate}}
              <!--{{ getRangeDurationLabel(currentEvent.endDateRange, 'end')}}-->
            </div>
          </div>
        </div>
        <div class="row" style="margin-bottom: 1rem;"
             *ngIf="isSingleDay()">
          <div class="col-md-12">
            <div class="form-group">
              {{ 'PAYROLL_PREPARE.duration' | translate }}:
              <number-input #singleRangeHour
                            [type]="'integer'"
                            [(ngModel)]="timeFields.singleDateRange.hours"
                            [classes]="['time-input']"
                            formControlName="singleHours"
                            (blur)="checkDateRange('singleDateRange', 'begin')"
                            (keyup)="setDateRange('singleDateRange',
                          singleRangeHour.input.nativeElement.value,
                          singleRangeMinute.input.nativeElement.value,
                          'begin')">
              </number-input>
              {{'PAYROLL_PREPARE.h' | translate}}
              <number-input #singleRangeMinute
                            [type]="'integer'"
                            [(ngModel)]="timeFields.singleDateRange.minutes"
                            [classes]="['time-input']"
                            formControlName="singleMinutes"
                            (blur)="checkDateRange('singleDateRange', 'begin')"
                            (keyup)="setDateRange('singleDateRange',
                          singleRangeHour.input.nativeElement.value,
                          singleRangeMinute.input.nativeElement.value,
                          'begin')">
              </number-input>
              {{'PAYROLL_PREPARE.m' | translate}}
              <!--{{ getRangeDurationLabel(currentEvent.singleDateRange, 'begin') }}-->
            </div>
          </div>
        </div>
      </form>


    </div>
    <div class="gp-modal-footer">

      <div class="btn-bar-wrapper">
        <div class="btn-bar btn-bar-sm btn-bar-align-end">
          <button type="button"
                  test-id="submitBtn"
                  class="btn btn-dark p-x-md"
                  [disabled]="!eventForm.valid || !isBeginBeforeEnd"
                  (click)="sendAbsence()">
            {{ 'EMPLOYEE_FORM.submit' | translate }}
          </button>
          <button type="button"
                  test-id="cancelBtn"
                  class="btn btn-secondary p-x-md"
                  (click)="eventpopup.close()">
            {{ 'FORMS.cancel' | translate }}
          </button>
        </div>
      </div>

    </div>
  </gp-modal>

  <ng-template #submenu let-employee>
    <ul class="dropdown-menu submenu">
      <ng-container>
        <li *ngIf="displayDeclareNoShowMenu(employee)"
            (click)="declareNoShow(employee)" class="dropdown-item pointer">
          <a>{{ 'TEAM_PLANNING.declare_no_show' | translate }}</a>
        </li>
        <li class="dropdown-item dropdown-submenu pointer">
          <a>{{ 'TEAM_PLANNING.add_to_team' | translate }}</a>
          <i aria-hidden="true" class="fa fa-light fa-caret-right"></i>
          <ul class="dropdown-menu">
            <li class="dropdown-item" (click)="addContractToTeam(employee, team)" *ngFor="let team of teams">
              {{team.name}}
            </li>
            <hr class="button-separator">
            <li class="dropdown-item text-primary"
                (click)="openCreateTeamModal(employee?.empContracts[0]?.id)">{{'TEAM_PLANNING.create_new_team' | translate}}</li>
          </ul>
        </li>
      </ng-container>
      <ng-container *ngIf="isCustomTeam">
        <li class="dropdown-item dropdown-submenu pointer">
          <a (click)="removeContractFromTeam(selectedTeam, employee)">{{ 'TEAM_PLANNING.remove_from_team' | translate }}</a>
        </li>
      </ng-container>
    </ul>
  </ng-template>
</div>
